import { useState } from "react";
import type { CommonData } from "../../../types/common";
import { Modals, ModalTypes } from "../../overview/loan/modals";
import { TinkAccountsRow } from "../../overview/rows/se/tinkAccountsRow";
import type { ExternalDataSourceProps } from "../types";

export const TinkSection = ({ flow, data }: ExternalDataSourceProps) => {
  const [selectedModal, setSelectedModal] = useState<string>("");
  const [selectedAccountId, setSelectedAccountId] = useState<string>("");
  const [selectedApplicantType, setSelectedApplicantType] = useState<
    "applicant" | "coapplicant"
  >("applicant");

  function handleModalClose() {
    setSelectedModal("");
    setSelectedAccountId("");
  }

  function handleViewTinkTransactions(
    accountId: string,
    applicantType: "applicant" | "coapplicant"
  ) {
    setSelectedAccountId(accountId);
    setSelectedApplicantType(applicantType);
    setSelectedModal(ModalTypes.TINK_TRANSACTIONS);
  }

  // Modals expects the common-process shape (flow.caseData.data / flow.caseData.flowId).
  const modalFlow = { caseData: { data, flowId: flow?.flowId } };

  return (
    <>
      <TinkAccountsRow
        data={data as CommonData}
        onViewTransactions={handleViewTinkTransactions}
      />
      <Modals
        flow={modalFlow}
        modalToShow={selectedModal}
        handleModalClose={handleModalClose}
        tinkAccountId={selectedAccountId}
        tinkApplicantType={selectedApplicantType}
      />
    </>
  );
};
